import { ProjectRuntimes } from '../config/types/runtimes';

export const isJestRuntime =
  process.env.REACT_APP_RUNTIME === ProjectRuntimes.JEST;

export const isDev = process.env.NODE_ENV === 'development';

export const isTestRuntime = process.env.NODE_ENV === 'test';

export const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
export const sentryEnvironment = process.env.REACT_APP_SENTRY_ENV;
export const reMatchApiUrl = process.env.REACT_APP_RE_MATCH_API;
